import { Button, Image, Row, Drawer, Badge, Input } from "antd";
import { Header } from "antd/es/layout/layout";
import { useState } from "react";
import {
  MenuOutlined,
  CloseSquareOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "wouter";
const { Search } = Input;

const TopHeader = () => {
  const [menuItems, setMenuItems] = useState(false);

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  //   const isLogin = useSelector((state) => state.authStore.isLogin);
  // const role = useSelector((state) => state.authStore.role);
  const items = [
    {
      key: 1,
      label: "Home",
      link: "/",
    },
    {
      key: 2,
      label: "About",
      link: "/about",
    },
  ];
  const onSearch = (value, _e, info) => console.log(info?.source, value);
  return (
    <Header className="bg-white w-full h-auto max-sm:w-full max-sm:px-4 max-lg:px-0">
      <div className="flex justify-between w-full items-center sm:px-16 gap-4">
        <Link to="/" className="flex gap-4 max-h-full">
          <img
            src="/assets/alp.svg"
            className="w-[80px]"
            preview={false}
            alt="ALP Logo"
          />
        </Link>

        <Row>
          <Search
            placeholder="Search..."
            onSearch={onSearch}
            style={{
              width: 300,
            }}
          />
        </Row>
        <nav className="flex items-center">
          <MenuOutlined
            className="sm:hidden"
            style={{ fontSize: "20px" }}
            onClick={() => {
              setMenuItems(true);
            }}
          />

          <div
            className={`max-sm:absolute top-0 right-0 z-10 max-sm:bg-white max-sm:h-screen max-sm:text-center transition-all ease-linear duration-500 ${
              menuItems
                ? "max-sm:w-[100vw] max-sm:p-8"
                : "max-sm:w-0 max-sm:p-0 overflow-hidden"
            }`}
          >
            <CloseSquareOutlined
              className={`sm:hidden text-[#000] float-end ${
                menuItems ? "null" : "hidden"
              }`}
              style={{ fontSize: "24px" }}
              onClick={() => {
                setMenuItems(false);
              }}
            />
            <ul className="sm:flex gap-8 items-center justify-center max-sm:text-left max-sm:w-max max-sm:mx-auto max-sm:p-8 font-semibold sm:text-[16px]">
              {items.map((item) => (
                <li
                  className="text-[#000] leading-normal max-sm:my-8"
                  key={item.key}
                >
                  <Link
                    to={item.link}
                    onClick={() => {
                      setMenuItems(false);
                    }}
                    className="hover:text-[#B91C1C]"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li className="text-[#000] leading-normal max-sm:my-8">
                <Link
                  to=""
                  onClick={() => {
                    setOpen(true);
                  }}
                  className="hover:text-[#B91C1C]"
                >
                  Categories <DownOutlined className="text-[12px] mt-auto" />
                </Link>
                <Drawer
                  title="Categories"
                  onClose={() => {
                    setOpen(false);
                  }}
                  open={open}
                  placement="top"
                  className="h-min bg-gradient-to-b from-[#FFFFFF] to-[#626365]/30"
                >
                  <div className="flex items-center gap-8 py-8">
                    <div className="rounded-xl w-1/3 text-center">
                      <Link to="/category">
                        <Image
                          onClick={() => {
                            setOpen(false);
                          }}
                          src="/assets/logo/automotive.png"
                          preview={false}
                        />
                      </Link>
                    </div>
                    <div className="rounded-xl w-1/3 text-center">
                      <Link to="/category">
                        <Image
                          onClick={() => {
                            setOpen(false);
                          }}
                          src="/assets/logo/sports.png"
                          preview={false}
                        />
                      </Link>
                    </div>
                    <div className="rounded-xl w-1/3 text-center">
                      <Link to="/category">
                        <Image
                          onClick={() => {
                            setOpen(false);
                          }}
                          src="/assets/logo/ac.png"
                          preview={false}
                        />
                      </Link>
                    </div>
                  </div>
                </Drawer>
              </li>
              <li>
                <Link to="/admin/order-requests">
                  <Button className="bg-[#0474B8] text-white border-0 font-semibold">
                    Sales Log In
                  </Button>
                </Link>
              </li>
              {/* {!isLogin ? (
                <>
                  <li>
                    <Link to="/login/dealer">
                      <Button className="bg-[#0474B8] text-white border-0 font-semibold">
                        Login as Dealer
                      </Button>
                    </Link>
                  </li>
                  <li>
                    <Link to="/login/retailer">
                      <Button className="bg-[#B91C1C] text-white border-0 font-semibold">
                        Login as Retailer
                      </Button>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="pe-2 flex items-center">
                    <Link to="/cart">
                      <Badge count={5} size="small">
                        <Image
                          src="/assets/icons/cart.svg"
                          preview={false}
                          className="object-contain"
                        />
                      </Badge>
                    </Link>
                  </li>
                  <li>
                    <Button
                      className="bg-[#B91C1C] text-white border-0 font-semibold"
                      onClick={() => {
                        // dispatch(logout());
                      }}
                    >
                      Log Out
                    </Button>
                  </li>
                </>
              )} */}
            </ul>
          </div>
        </nav>
      </div>
    </Header>
  );
};

export default TopHeader;
